import { Drawer } from 'antd'
import React from 'react'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { Tenant } from '../../../Tenants/models'
import { Issuer } from '../../models'
import { CreateBespokeRfqEmail } from './CreateBespokeRfqEmail'

interface CreateBespokeRfqEmailDrawerProps {
  isVisible: boolean
  onClose: () => void
  issuers: Issuer[]
  tenants: Tenant[]
  onSuccess: () => void
}

export const CreateBespokeRfqEmailDrawer = ({
  isVisible,
  onClose,
  issuers,
  tenants,
  onSuccess,
}: CreateBespokeRfqEmailDrawerProps) => (
  <Drawer
    title="Create Bespoke RFQ Email"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
    className="drawer-rfq"
  >
    <CreateBespokeRfqEmail issuers={issuers} tenants={tenants} onSuccess={onSuccess} />
  </Drawer>
)
